import React, { cloneElement, useEffect, useState } from 'react';
import { SvgIcon } from '../../../../core/icons';
import { combineClassNames } from '../../../../core/css';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { TranslateHTML, useTranslate } from '../../../../core/translate';

const STANDARD = 'standard';
const NA = 'n/a';
const AVAILABLE = 'available';

const CompareTableCell = ({
  className,
  features = [],
  columnOption,
  staticTable,
}) => {
  const { activeIndex: index, animateNext } = columnOption || {};
  const [animateToNext, setAnimateToNext] = useState(animateNext);
  const currentFeatureVal = features[index];
  const lowercaseVal = currentFeatureVal && currentFeatureVal.toLowerCase();
  const tableCellRef = React.createRef();
  const translate = useTranslate();

  useEffect(() => {
    if (animateNext !== animateToNext) {
      setAnimateToNext(animateNext);
    }
  }, [animateNext]);

  const getIconName = () => {
    if (lowercaseVal === STANDARD) return 'check-mark';

    if (lowercaseVal === NA) return 'collapse-cell';

    return null;
  };

  const iconName = getIconName();
  const getClassNames = () => {
    if (!staticTable) {
      return animateNext ? 'left' : 'right';
    }
    return '';
  };
  const classNames = getClassNames();

  const getCellValue = () => {
    if (lowercaseVal === NA) {
      return (
        <span className="table-cell__label">
          <TranslateHTML value="not.available" />
        </span>
      );
    }

    const cellValue =
      lowercaseVal === STANDARD || lowercaseVal === AVAILABLE
        ? translate(`${lowercaseVal}.v3`)
        : currentFeatureVal;
    return (
      <span
        className="table-cell__label"
        dangerouslySetInnerHTML={{
          __html: cellValue || translate('byo.engine.compare.na'),
        }}
      />
    );
  };

  const cellValue = getCellValue();

  const alignContent =
    lowercaseVal === NA ||
    lowercaseVal === STANDARD ||
    lowercaseVal === AVAILABLE;

  return (
    <div className="compare-table-cell" ref={tableCellRef}>
      <div className="table-cell__container">
        <TransitionGroup
          childFactory={(child) =>
            cloneElement(child, {
              classNames,
            })
          }
          component={null}>
          <CSSTransition
            key={`${currentFeatureVal}${index}`}
            timeout={staticTable ? 0 : 375}>
            <div className={combineClassNames('table-cell', className)}>
              <span
                className={`table-cell__content${
                  alignContent ? ' table-cell__content--aligned' : ''
                }`}>
                {iconName && (
                  <SvgIcon
                    name={iconName}
                    className={combineClassNames(
                      'button__icon--left',
                      'table-cell__icon',
                      iconName ? `table-cell__icon--${iconName}` : ''
                    )}
                  />
                )}
                {alignContent && !iconName && (
                  <i className="table-cell__icon-placeholder button__icon--left" />
                )}
                {cellValue}
              </span>
            </div>
          </CSSTransition>
        </TransitionGroup>
      </div>
    </div>
  );
};

export default CompareTableCell;
